import { List, Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledSection = styled(Section)`
  margin-bottom: 2rem;
  padding: 0;
`;

export const StyledList = styled(List)`
  margin-bottom: 1rem;
  padding-left: 2.5rem;
`;
